/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface GetContactListResponse
 */
export interface GetContactListResponse {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof GetContactListResponse
     */
    id: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof GetContactListResponse
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GetContactListResponse
     */
    email: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetContactListResponse
     */
    isGlobalContact?: boolean;
}

/**
 * Check if a given object implements the GetContactListResponse interface.
 */
export function instanceOfGetContactListResponse(value: object): value is GetContactListResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function GetContactListResponseFromJSON(json: any): GetContactListResponse {
    return GetContactListResponseFromJSONTyped(json, false);
}

export function GetContactListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetContactListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': ApiUserTasksGetPageParameterFromJSON(json['id']),
        'name': json['name'],
        'email': json['email'],
        'isGlobalContact': json['isGlobalContact'] == null ? undefined : json['isGlobalContact'],
    };
}

export function GetContactListResponseToJSON(json: any): GetContactListResponse {
    return GetContactListResponseToJSONTyped(json, false);
}

export function GetContactListResponseToJSONTyped(value?: GetContactListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': ApiUserTasksGetPageParameterToJSON(value['id']),
        'name': value['name'],
        'email': value['email'],
        'isGlobalContact': value['isGlobalContact'],
    };
}

